import React from "react";
import { Collapse, Tooltip } from "antd";
import { t } from "i18next";

type SubtitlesCollapseProps = {
    headings: string[];
    activeIndex?: number;
    className: string;
};

export const SubtitlesCollapse: React.FC<SubtitlesCollapseProps> = ({ headings, activeIndex, className }) => {
    const scrollToHeading = (index: number) => {
        const target = document.querySelectorAll(".article-content h2")[index] as HTMLElement;
        if (target) {
            const yOffset = -100;
            const y = target.getBoundingClientRect().top + window.scrollY + yOffset;
            window.scrollTo({ top: y, behavior: "smooth" });

            target.classList.add("highlighted");
            setTimeout(() => target.classList.remove("highlighted"), 2000);
        }
    };

    return (
        <Collapse
            className={className}
            defaultActiveKey={['0']}
            style={{
                height: 'fit-content',
                width: '100%',
                
                alignSelf: 'start',
                backgroundColor: '#3f51b51a',
                borderRadius: '5px',
            }}
            expandIcon={({ isActive }) => (
                <i className="fi fi-br-angle-right"
                    style={{
                        transform: `rotate(${isActive ? 90 : 0}deg)`,
                        color: 'grey',
                        transition: 'transform 0.2s',
                    }}
                >
                </ i>
            )
            }
            items={
                [
                    {
                        key: '1',
                        label: <h3 style={{ fontSize: '14px', color: 'var(--color-text)', }} >Alt başlıklar</h3>,
                        children: (
                            <ol style={{ paddingLeft: '10px' }}>
                                {headings.map((text, index) => (
                                    <li
                                        key={index}
                                        className={activeIndex === index ? "active" : ""}
                                        style={{
                                            padding: '5px',
                                            fontSize: '13px',
                                            wordBreak: 'break-word',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            scrollToHeading(index);
                                        }}
                                    >
                                        {text}
                                    </li>
                                ))}
                            </ol>
                        ),
                    },
                ]}
        />
    );
};
